// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ch-4";
export var closeButton = "_ch-6";
export var dismissButton = "_ch-3";
export var editImageWithAiContainer = "_ch-8";
export var imageUploadWrapper = "_ch-7";
export var misspelledWord = "_ch-5";
export var spellCheckContainer = "_ch-2";
export var spin = "_ch-1";
export var spinning = "_ch-0";